import React from 'react';

export default function SummaryCard({ props: p, dir }) {
  const rows = p.rows || [];
  const extra = p.data;

  return (
    <div className="ui-summary-card" dir={dir}>
      {p.title && <div className="ui-part-title">{p.title}</div>}
      {extra && typeof extra === 'object' && !Array.isArray(extra) && (
        <div className="ui-summary-rows">
          {Object.entries(extra).map(([k, v]) => (
            <div key={k} className="ui-summary-row">
              <span className="ui-summary-key">{k}</span>
              <span className="ui-summary-val">{String(v)}</span>
            </div>
          ))}
        </div>
      )}
      {Array.isArray(rows) &&
        rows.map((row, i) => (
          <div key={i} className="ui-summary-row">
            <span>{row.label || row.key}</span>
            <span>{row.value}</span>
          </div>
        ))}
    </div>
  );
}
